// shared/ui/AsistentesSection.jsx  (presentacional: props in, callbacks out; el selector de productor siempre está visible)
import React from 'react';
import { Autocomplete, InputAdornment, TextField, createFilterOptions } from '@mui/material';
import { detalleProductor, stringifyProductor } from '../domain/productor';
import SectionCard from './SectionCard.jsx';
import AsistenteCard from './AsistenteCard.jsx';
import { autocompleteFieldSx } from './autocompleteSx.js';

const filterOptions = createFilterOptions({ limit: 100, stringify: stringifyProductor });

// asistentes: [{ id, uuid, nombre, total_parcelas }]; fotos: { [uuid]: url|null|undefined }; options: productores aún no seleccionados.
const AsistentesSection = ({ asistentes, options, loading = false, disabled = false, error, fotos = {}, onAdd, onRemove }) => (
  <SectionCard>
    <div className="row mb-3">
      <div className="col-md-6 mb-3 mb-md-0">
        <h4 style={{ marginBottom: 2 }}>{`Asistentes (${asistentes.length})`}</h4>
        <div style={{ color: '#6c757d' }}>Agrega los productores que participaron en la capacitación.</div>
      </div>
      <div className="col-md-6">
        <Autocomplete
          options={options}
          loading={loading}
          disabled={disabled}
          filterOptions={filterOptions}
          getOptionLabel={option => option.nombre.toUpperCase()}
          renderOption={(props, option) => {
            const detalle = detalleProductor(option);
            return (
              <li {...props} key={option.id}>
                <div style={{ minWidth: 0 }}>
                  <div>{option.nombre.toUpperCase()}</div>
                  {detalle && <div style={{ fontSize: 12, color: '#6c757d' }}>{detalle}</div>}
                </div>
              </li>
            );
          }}
          isOptionEqualToValue={(option, selected) => option.id === selected.id}
          value={null}
          blurOnSelect
          onChange={(event, option) => option && onAdd(option.id)}
          noOptionsText="Sin resultados"
          loadingText="Cargando..."
          renderInput={params => (
            <TextField
              {...params}
              label="Productor*"
              placeholder="Busca al productor que desees agregar"
              error={!!error}
              sx={autocompleteFieldSx}
              helperText={error || undefined}
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    <InputAdornment position="start">
                      <i className="fa fa-user" />
                    </InputAdornment>
                    {params.InputProps.startAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </div>
    </div>
    {asistentes.length === 0 ? (
      <div
        style={{
          background: '#F7F1E3',
          borderRadius: 12,
          padding: 24,
          textAlign: 'center',
          color: '#8a7f68',
        }}>
        Aún no hay asistentes seleccionados
      </div>
    ) : (
      <div className="d-flex flex-wrap" style={{ gap: 12 }}>
        {asistentes.map(asistente => (
          <AsistenteCard key={asistente.id} asistente={asistente} fotoUrl={fotos[asistente.uuid]} onRemove={onRemove} disabled={disabled} />
        ))}
      </div>
    )}
  </SectionCard>
);

export default AsistentesSection;
